import React, { lazy } from 'react';
import { motion } from 'framer-motion';
import { ArrowUpRightIcon, NewspaperIcon } from 'lucide-react';
import { useLanguage } from '../lib/i18n';
export function PressRecognition() {
  const {
    t
  } = useLanguage();
  const ARTICLES = [{
    id: 'crobot',
    title: t.pressArticle1Title,
    source: 'Lider Media',
    description: t.pressArticle1Desc,
    url: 'https://lidermedia.hr/zeleno-i-digitalno/tko-se-krije-iza-crobota-novog-hrvatskog-ai-chatbota-150356/',
    imageUrl: 'https://image.thum.io/get/width/600/crop/340/noanimate/https://lidermedia.hr/zeleno-i-digitalno/tko-se-krije-iza-crobota-novog-hrvatskog-ai-chatbota-150356/'
  }, {
    id: 'digital-transformation',
    title: t.pressArticle2Title,
    source: 'Lider Media',
    description: t.pressArticle2Desc,
    url: 'https://lidermedia.hr/zeleno-i-digitalno/mali-jutarnji-razgovor-s-crobotom-prvom-hrvatskom-ai-platformom-150293/',
    imageUrl: 'https://image.thum.io/get/width/600/crop/340/noanimate/https://lidermedia.hr/zeleno-i-digitalno/mali-jutarnji-razgovor-s-crobotom-prvom-hrvatskom-ai-platformom-150293/'
  }, {
    id: 'elementor',
    title: t.pressArticle3Title,
    source: 'Elementor',
    description: t.pressArticle3Desc,
    url: 'https://elementor.com/blog/image-optimizer-case-study-spread/',
    imageUrl: 'https://image.thum.io/get/width/600/crop/340/noanimate/https://elementor.com/blog/image-optimizer-case-study-spread/'
  }];
  return <section className="py-24 md:py-32 px-6 md:px-12 lg:px-20 z-10 relative" data-id="element-267">
      <div className="max-w-[1400px] mx-auto" data-id="element-268">
        <div className="border-t border-border pt-16 md:pt-20" data-id="element-269">
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8,
          ease: [0.16, 1, 0.3, 1]
        }} className="mb-14 md:mb-16" data-id="element-270">
            <div className="flex items-center gap-3 mb-4" data-id="element-271">
              <NewspaperIcon className="w-4 h-4 text-secondary/60" data-id="element-272" />
              <p className="text-secondary text-xs tracking-[0.2em] uppercase font-light" data-id="element-273">
                {t.pressOverline}
              </p>
            </div>
            <h2 className="text-2xl md:text-4xl lg:text-5xl font-display font-bold text-primary tracking-tight mb-6 leading-snug" data-id="element-274">
              {t.pressTitle1}
              <br data-id="element-275" />
              {t.pressTitle2}
            </h2>
            <p className="text-secondary text-base md:text-lg font-light max-w-2xl leading-relaxed" data-id="element-276">
              {t.pressDesc}
            </p>
          </motion.div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8 max-w-5xl" data-id="element-277">
            {ARTICLES.map((article, index) => <motion.a key={article.id} href={article.url} target="_blank" rel="noopener noreferrer" initial={{
            opacity: 0,
            y: 30
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.7,
            delay: index * 0.15,
            ease: [0.16, 1, 0.3, 1]
          }} className="group block p-3 md:p-5 rounded-xl border border-border hover:border-secondary/30 hover:bg-white/[0.02] transition-all duration-500" data-id="element-278">
                <div className="relative overflow-hidden rounded-lg mb-3 md:mb-4 aspect-[3/1] md:aspect-[21/9] bg-surface" data-id="element-279">
                  <img src={article.imageUrl} alt={article.title} className="absolute inset-0 w-full h-full object-cover object-left-top transition-all duration-700 ease-out grayscale group-hover:grayscale-0 group-hover:scale-[1.03]" loading="lazy" data-id="element-280" />
                  <div className="absolute inset-0 bg-background/50 group-hover:bg-background/25 transition-colors duration-500" data-id="element-281" />
                  <div className="absolute top-2 right-2 w-7 h-7 rounded-full backdrop-blur-sm flex items-center justify-center opacity-0 group-hover:opacity-100 group-hover:bg-white/10 transition-all duration-500" data-id="element-282">
                    <ArrowUpRightIcon className="w-3 h-3 text-primary" data-id="element-283" />
                  </div>
                </div>
                <span className="inline-block text-[10px] text-secondary/50 tracking-[0.15em] uppercase font-light px-2 py-0.5 rounded-full border border-border mb-2" data-id="element-284">
                  {article.source}
                </span>
                <h3 className="text-sm md:text-base font-display font-bold text-primary tracking-tight mb-1.5 leading-snug group-hover:text-secondary transition-colors duration-300" data-id="element-285">
                  {article.title}
                </h3>
                <p className="text-primary/80 text-[11px] md:text-xs leading-relaxed font-light" data-id="element-286">
                  {article.description}
                </p>
              </motion.a>)}
          </div>
        </div>
      </div>
    </section>;
}